import React, { useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import './EnquiryForm.css';
import {
  CRUISE_PHONE_DISPLAY,
  EXPLORE_PHONE_DISPLAY,
  MAIN_PHONE_DISPLAY,
} from '../constants/contact';

const EnquiryForm = () => {
  const { pathname } = useLocation();
  const isExplore = pathname.startsWith('/explore');
  const isCruise = pathname.startsWith('/cruises');
  const phonePlaceholder = isCruise
    ? CRUISE_PHONE_DISPLAY
    : isExplore
      ? EXPLORE_PHONE_DISPLAY
      : MAIN_PHONE_DISPLAY;
  const formRef = useRef();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    carInterest: ''
  });
  
  const [status, setStatus] = useState({
    submitting: false,
    submitted: false,
    error: null
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ submitting: true, submitted: false, error: null });

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("access_key", "f3622f40-7261-4f2c-9728-92274c85929a");
      formDataToSend.append("name", formData.name);
      formDataToSend.append("email", formData.email);
      formDataToSend.append("phone", formData.phone);
      formDataToSend.append("car_model", formData.carInterest || 'Not specified');
      formDataToSend.append("subject", `Car Rental Enquiry - ${formData.carInterest || 'General'}`);

      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formDataToSend
      });

      const data = await response.json();

      if (data.success) {
        setStatus({ submitting: false, submitted: true, error: null });
        setFormData({
          name: '',
          email: '',
          phone: '',
          carInterest: ''
        });
      } else {
        setStatus({ submitting: false, submitted: false, error: data.message || 'Failed to send enquiry. Please try again.' });
      }
    } catch (error) {
      setStatus({ submitting: false, submitted: false, error: 'Failed to send enquiry. Please try again or contact us directly.' });
    }
  };

  return (
    <section className="enquiry-form-section" id="enquiry">
      <div className="container">
        <h2 className="section-title">Get In Touch</h2>
        <p className="section-subtitle">Fill out the form below and we'll get back to you soon</p>
        
        <div className="form-container">
          <form ref={formRef} onSubmit={handleSubmit} className="enquiry-form">
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="John Doe"
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="john@example.com"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label htmlFor="phone">Phone Number *</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  placeholder={phonePlaceholder}
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="carInterest">Car Model *</label>
                <select
                  id="carInterest"
                  name="carInterest"
                  value={formData.carInterest}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select a car</option>
                  <option value="BMW 5 Series">BMW 5 Series</option>
                  <option value="Mercedes-Benz E-Class">Mercedes-Benz E-Class</option>
                  <option value="Audi Q7">Audi Q7</option>
                  <option value="Tesla Model 3">Tesla Model 3</option>
                  <option value="Porsche 911">Porsche 911</option>
                  <option value="Range Rover">Range Rover</option>
                  <option value="Lexus RX 350">Lexus RX 350</option>
                  <option value="Jaguar F-Type">Jaguar F-Type</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>

            {status.error && (
              <div className="error-message">{status.error}</div>
            )}

            {status.submitted && (
              <div className="success-message">
                Thank you! Your enquiry has been sent successfully. We'll get back to you soon.
              </div>
            )}

            <button 
              type="submit" 
              className="submit-button"
              disabled={status.submitting}
            >
              {status.submitting ? 'Sending...' : 'Send Enquiry'}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default EnquiryForm;

